import React from "react";

import { useLocation } from "react-router-dom";
import PageBanner from "../PageBanner";
import Card from "../ArticleCarousel/Card";
import List from "../../../components/List";
import Section from "../../../components/Section";
import Placeholder from "../../../assets/image/notfoundbg.jpeg";

import style from "./style.module.css";

export default function CategoryBasedList(props) {
    const {
        widgets = []
    } = props;
    const { pathname } = useLocation();

    let image = "";
    if (widgets[0].preview_image !== "" && widgets[0].preview_image !== null) {
        image = widgets[0].preview_image;
    }
    else {
        image = Placeholder;
    }

    return (
        <>
            {
                image !== "" && (
                    <PageBanner
                        preview_image={image}
                        name={widgets[0].name}
                        size = "1140x520"
                        backButton={false}
                    />
                )
            }
            <Section className={`categoryBasedList ${style.categoryBasedList}`}>
                <div className={`categoryBasedListRows ${style.categoryBasedListRow}`}>
                    <List
                        url={`/categorisation${pathname}`}
                        emptyText={"No result"}
                        attribute="category_based_list"
                        className={style.categoryBasedListLayout}
                        listClassName={style.categoryBasedListList}
                        sort={false}
                        limit={20}
                        loadOnValidFilter={false}
                        itemTemplate={(item) => {
                            if (item.name) {
                                return (
                                    <Card
                                        item={item}
                                        onClick={() => {

                                        }}
                                        onHover={() => { }}
                                    />
                                )
                            }
                        }}
                    />
                </div>
            </Section>
        </>
    )
}